import Hotjar from '@hotjar/browser';
import { useEffect } from 'react';

const siteId = 6420405;
const hotjarVersion = 6;

export const MetricsHotjar = () => {
  useEffect(() => {
    Hotjar.init(siteId, hotjarVersion);
  }, []);
  
  return null;
};
